export class AppScreenUtil {
    
    static scrollModalToTop() {
        const dialog = document.querySelector('.mat-dialog-container');
        if (dialog) dialog.scrollTop = 0;
    }
    
    static scrollAllModalToTop() {
        const dialog: NodeListOf<Element> = document.querySelectorAll('.mat-dialog-container');
        dialog.forEach(element => {
            element.scrollTop = 0;
        });
    }

    static scrollModalToTopByIndex(index: number) {
        const dialog = document.querySelectorAll('.mat-dialog-container')[index]
        if (dialog) dialog.scrollTop = 0;
    }
}